import React, { useState, useEffect } from "react";
import styles from "./style.module.css";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
import LabeledToggle from "@/components/Inputs/Toggle/Toggle";
import { InfoTip } from "./InfoTip";
import { ProviderCreator } from "./ProviderEditor";
const SkillsCatalog = ({ skillsOptions, isSkillsLoading, selectedSkills, updateSkills, selectedProviders, updateSelectedProviders, openShellClient }) => {
    return (React.createElement("div", null, isSkillsLoading ? (React.createElement("div", { className: "flex flex-col items-center" },
        React.createElement(LoadingIndicator, { style: { scale: ".6", margin: "0px" } }),
        React.createElement("div", null, "Loading Skills Catalog..."))) : skillsOptions?.length > 0 ? (skillsOptions.map((skill) => {
        return (React.createElement(CatalogSkill, { key: `catalogSkill_${skill?.id}`, skill: skill, selectedSkills: selectedSkills, updateSkills: updateSkills, selectedProviders: selectedProviders, updateSelectedProviders: updateSelectedProviders, openShellClient: openShellClient }));
    })) : (React.createElement("div", null, "No approved skills found"))));
};
const CatalogSkill = ({ openShellClient, skill, selectedSkills, updateSkills, selectedProviders, updateSelectedProviders }) => {
    const [validSkillProviders, setValidSkillProviders] = useState([]);
    const isEnabled = (selectedSkills ?? []).includes(skill?.id);
    const refreshProviders = () => {
        if ((skill?.required_env?.length ?? 0) > 0) {
            openShellClient.getProviders(skill.required_env).then(setValidSkillProviders);
        }
    };
    const selectedProvider = validSkillProviders.find((p) => selectedProviders.find((sp) => p.name == sp) !== undefined);
    useEffect(() => {
        refreshProviders();
    }, [skill?.required_env?.length]);
    const updateIsEnabled = (val) => {
        let skillsUpdate = [...selectedSkills];
        if (isEnabled && !val) {
            skillsUpdate = skillsUpdate.filter((s) => s !== skill?.id);
        }
        else if (!isEnabled && val) {
            skillsUpdate = [...selectedSkills, skill?.id];
        }
        return updateSkills(skillsUpdate);
    };
    const handleProviderUpdate = (update) => {
        updateSelectedProviders(selectedProviders.filter((sp) => validSkillProviders.find((p) => p.name == sp) === undefined).concat([update]));
    };
    return (React.createElement("div", { className: styles.catalogSkillWrapper },
        React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement("div", { className: styles.catalogSkillContent },
                React.createElement("div", { className: styles.catalogSkillName }, skill?.id),
                skill?.description && React.createElement("div", { className: styles.catalogSkillDescription }, skill?.description),
                skill?.required_env?.length > 0 && (React.createElement("div", null,
                    React.createElement("div", { className: styles.catalogSkillRequiredKeysWrapper },
                        "Required Keys:",
                        React.createElement("div", { className: "flex items-center ml-[10px]" }, skill?.required_env.map((requiredKey) => {
                            return React.createElement("div", { className: styles.catalogSkillRequiredKey }, requiredKey);
                        })))))),
            React.createElement("div", { className: styles.catalogSkillToggleWrapper },
                React.createElement(LabeledToggle, { style: { display: "block", marginRight: "8px" }, checked: isEnabled, disabled: (skill?.required_env?.length ?? 0) > 0 &&
                        selectedProvider === undefined &&
                        validSkillProviders.length == 0, onChange: () => {
                        updateIsEnabled(!isEnabled);
                        if (!isEnabled && selectedProvider === undefined && validSkillProviders.length > 0) {
                            handleProviderUpdate(validSkillProviders[0].name);
                        }
                    }, isAibleColors: true }),
                React.createElement("div", { className: "ml-[-8px]" }, "Enable"))),
        skill?.required_env?.length > 0 && (React.createElement("div", null,
            React.createElement("div", { className: styles.labelWithInfo },
                React.createElement("label", { className: styles.label }, "Credential Provider"),
                React.createElement(InfoTip, { title: "Credential Provider" }, "The provider for the skill's required keys.")),
            validSkillProviders.length > 0 && (React.createElement("select", { style: { marginBottom: "8px", width: "225px" }, className: styles.select + " " + styles.inputSmall, value: selectedProvider?.name, onChange: (e) => handleProviderUpdate(e.target.value) }, validSkillProviders.map((provider) => (React.createElement("option", { key: provider.name, value: provider.name }, provider.name))))),
            React.createElement(ProviderCreator, { defaultProviderFactory: () => ({
                    name: "",
                    type: "generic",
                    credentials: (skill?.required_env ?? []).map((key) => ({ key: key, value: "" })),
                    configs: []
                }), onCreated: (created) => {
                    handleProviderUpdate(created.name);
                }, openShellClient: openShellClient, profileFilter: (p) => {
                    const required = skill?.required_env ?? [];
                    return (required.length == 0 ||
                        required.every((r) => p.credentials === undefined ||
                            p.credentials.find((c) => c.env_vars === undefined || c.env_vars.find((e) => e == r))));
                } })))));
};
export default SkillsCatalog;
